// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebase: {
    apiKey: "AIzaSyBHucoVtYrUFKW_k_698kUTrY_W0NXTUTU",
    authDomain: "rleaf-10afa.firebaseapp.com",
    projectId: "rleaf-10afa",
    storageBucket: "rleaf-10afa.appspot.com",
    messagingSenderId: "129223981799",
    appId: "1:129223981799:web:eeaab5d2e90c5605440042",
    measurementId: "G-GR2CF8D9Y5"
  },
  production: false,
  stripe_token: 'STRIPE_TOKEN',
  paypal_token: 'PAYPAL_TOKEN',
  resendApiKey: 're_ywtyMytT_Bk6fDa1PxfZQHwoktfZxH366'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
